import { render, staticRenderFns } from "./DEBUG_PAGE.vue?vue&type=template&id=2a2d11bc&scoped=true&"
import script from "./DEBUG_PAGE.vue?vue&type=script&lang=ts&"
export * from "./DEBUG_PAGE.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d11bc",
  null
  
)

export default component.exports